import { BarDataSet } from '@models/index';

export class BarGraphData {
    labels: string[];
    datasets: BarDataSet[];
    options: any;
}
